import React from "react";
import Typography from "@material-ui/core/Typography";

import { TypographColor } from "./utils";

type Props = {
  color?: TypographColor;
  [other: string]: any;
};

export function Label({ children, ...rest }: Props) {
  return (
    <Typography component={"span" as any} {...rest}>
      {children}
    </Typography>
  );
}

Label.defaultProps = {
  color: "inherit"
};
